// Admin dashboard tab configuration
export const ADMIN_TAB_LINKS = [
    {
        label: 'Partners',
        value: 'partners',
    },
    {
        label: 'Work Scopes',
        value: 'work-scopes',
    },
    {
        label: 'Migration',
        value: 'migration',
    },
    {
        label: 'Region Settings',
        value: 'region-settings',
    },
] as const

export type AdminTabLink = (typeof ADMIN_TAB_LINKS)[number]['value']

/** @deprecated Legacy tab slug; redirects to work-scopes */
export type LegacyAdminTabLink = AdminTabLink | 'tools-supplies'

export const SEARCH_PARAMS_TAB_KEY = 'tab'

